// First: the browser offers "install this app" once, early, and only to whoever is listening.
import "./install";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { PreferencesProvider, setDataService } from "@strat/ui";
import "@strat/ui/styles.css";
import "./hub.css";

import { App } from "./App";
import { labService } from "./labService";

// The lab's pages read data through this one interface; set before anything renders.
setDataService(labService);

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

// The service worker only shows push notifications; it needs a secure context
// (https, or localhost) and is simply absent elsewhere.
if ("serviceWorker" in navigator && window.isSecureContext) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}

const root = document.getElementById("root");
if (!root) throw new Error("No #root element — index.html and this entry disagree.");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <PreferencesProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PreferencesProvider>
    </QueryClientProvider>
  </StrictMode>,
);
